import { Index } from '../views';
import { Nosotros } from '../views/Nosotros';
import { Servicios } from '../views/Servicios';
import { AnalisisCredito } from '../views/AnalisisCredito';
import { Pld } from '../views/Pld';
import { Dispersion } from '../views/Dispersion';
import { Cobranza } from '../views/Cobranza';
import { CardEmision } from '../views/CardEmision';
import { LockPhone } from '../views/LockPhone';
import { PayServices } from '../views/PayServices';
import { CampaignNoti } from '../views/CampaignNoti';
import { Scoring } from '../views/Scoring';
import { Beneficios } from '../views/Beneficios';
import { CoreBancario } from '../views/CoreBancario';
import { NotFound } from '../views/NotFound';
import { Contact } from '../views/Contact';
import { AvisoPrivacidad } from '../views/AvisoPrivacidad';
import { TerminosCondiciones } from '../views/TerminosCondiciones';
import { ThanksView } from '../views/ThanksView';
import { SiteMap } from '../views/SiteMap';
import { UseCases } from '../views/UseCases';

export const routes = {  en: [
    { id: 'index', path: '/en', element: <Index /> },
    { id: 'about-us', path: '/en/about-us', element: <Nosotros /> },
    { id: 'benefits', path: '/en/benefits', element: <Beneficios /> },
    { id: 'banking-core', path: '/en/banking-core', element: <CoreBancario /> },
    { id: 'onboarding', path: '/en/onboarding', element: <Servicios /> },
    { id: 'credit-analysis', path: '/en/credit-analysis', element: <AnalisisCredito /> },
    { id: 'aml', path: '/en/anti-money-laundering', element: <Pld /> },
    { id: 'payment-dispersion', path: '/en/payment-dispersion', element: <Dispersion /> },
    { id: 'collections', path: '/en/collections', element: <Cobranza /> },
    { id: 'card-issuance', path: '/en/card-issuance', element: <CardEmision /> },
    { id: 'device-lock', path: '/en/device-lock', element: <LockPhone /> },
    { id: 'pay-services', path: '/en/pay-services', element: <PayServices /> },
    { id: 'notifications', path: '/en/notifications', element: <CampaignNoti /> },
    { id: 'alternative-scoring', path: '/en/alternative-scoring', element: <Scoring /> },
    { id: 'credit-use-case', path: '/en/credit-use-case', element: <UseCases /> },
    { id: 'sitemap', path: '/en/sitemap', element: <SiteMap /> },
    { id: 'contact', path: '/en/contact', element: <Contact /> },
    { id: 'thank-you', path: '/en/thank-you', element: <ThanksView /> },
    { id: 'privacy-notice', path: '/en/privacy-notice', element: <AvisoPrivacidad /> },
    { id: 'terms', path: '/en/terms-and-conditions', element: <TerminosCondiciones /> },
    { id: 'not-found', path: '/en/*', element: <NotFound /> },
  ],  es: [
    { id: 'index', path: '/', element: <Index /> },
    { id: 'about-us', path: '/nosotros', element: <Nosotros /> },
    { id: 'benefits', path: '/beneficios', element: <Beneficios /> },
    { id: 'banking-core', path: '/core-bancario', element: <CoreBancario /> },
    { id: 'onboarding', path: '/onboarding', element: <Servicios /> },
    { id: 'credit-analysis', path: '/analisis-crediticio', element: <AnalisisCredito /> },
    { id: 'aml', path: '/pld', element: <Pld /> },
    { id: 'payment-dispersion', path: '/dispersion-pagos', element: <Dispersion /> },
    { id: 'collections', path: '/cobranza', element: <Cobranza /> },
    { id: 'card-issuance', path: '/emision-tarjetas', element: <CardEmision /> },
    { id: 'device-lock', path: '/bloqueo-dispositivos', element: <LockPhone /> },
    { id: 'pay-services', path: '/pago-servicios', element: <PayServices /> },
    { id: 'notifications', path: '/notificaciones', element: <CampaignNoti /> },
    { id: 'alternative-scoring', path: '/score-alternativo', element: <Scoring /> },
    { id: 'credit-use-case', path: '/caso-de-uso-credito', element: <UseCases /> },
    { id: 'sitemap', path: '/sitemap', element: <SiteMap /> },
    { id: 'contact', path: '/contacto', element: <Contact /> },
    { id: 'thank-you', path: '/gracias', element: <ThanksView /> },
    { id: 'privacy-notice', path: '/aviso-de-privacidad', element: <AvisoPrivacidad /> },
    { id: 'terms', path: '/terminos-y-condiciones', element: <TerminosCondiciones /> },
    { id: 'not-found', path: '*', element: <NotFound /> },
  ],
};
